const SectionContent = {
  topSection: {
    en: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_waitlist.png`,
      title: 'Restaurant Waitlist',
      description: `Chowbus Waitlist allows your guests to book a table at your restaurant anytime, anywhere.`,
      youtubeVideoId: '',
    },
    zh: {
      poster: `${process.env.ASSETS_PREFIX}/products/products_waitlist.png`,
      title: '餐馆预约服务和座位',
      description: 'Chowbus等位系统覆盖多个渠道，让顾客能随时随地预约等位。',
      youtubeVideoId: '',
    },
  },
  advances: {
    en: {
      title: `Chowbus Waitlist is a powerful, but simple way to streamline your front of house, and help your staff focus on what matters most, connecting with guests`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_1.png`,
          imageAlt: 'Use Waitlist to seat more diners',
          title: 'Use Waitlist to seat more diners',
          description:
            'Increase covers by making your tables easier to book. Offer a one-click way for plan-ahead & last-second diners to book a table, wait where they want, & show up happy instead of frustrated.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_2.png`,
          imageAlt: 'Use Waitlist to manage the line without staff',
          title: 'Use Waitlist to manage the line without staff',
          description:
            'Use Chowbus Waitlist App, Google Waitlist and restaurant website reservation at the same time. Guests can join the waitlist both online and offline, anytime, anywhere.',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_3.png`,
          imageAlt: 'Use POS to track real-time table info and waiting time',
          title: 'Use POS to track real-time table info and waiting time',
          description: `Integrate Chowbus Waitlist with Chowbus POS system, provide customers with accurate waiting time, and greatly improve customer's dining experience.`,
        },
      ],
    },
    zh: {
      title: `Chowbus等位系统一站式解决长时间等位的问题`,
      subTitle: ``,
      featureList: [
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_1.png`,
          imageAlt: '获取更多顾客',
          title: '获取更多顾客',
          description: '更多的顾客可以利用简单高效的等位系统预估准确的用餐时间，餐厅也可以安排更多顾客用餐',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_2.png`,
          imageAlt: '覆盖多种渠道',
          title: '覆盖多种渠道',
          description:
            '顾客可以通过餐厅线下等位机、线上等位App、餐厅网站、谷歌排队等方式取号、排队，拓宽了获取顾客的渠道',
        },
        {
          image: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_feature_3.png`,
          imageAlt: '优化等位体验',
          title: '优化等位体验',
          description: '顾客可以随时随地取号并查看排队进程、获取最新的等待时间，无需在餐厅排队等待，提升等位、用餐体验',
        },
      ],
    },
  },

  features: {
    en: {
      title: 'The easiest and most effective way to manage waitlist',
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: 'Guests can join your digital waitlist anytime, anywhere',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_1.png`,
          description: `With one click, guests can easily join your restaurant's waitlist system through Chowbus Waitlist App, Google Waitlist and restaurant website reservation.`,
          // items: [
          //   {
          //     title: 'Guests can join your digital waitlist anytime, anywhere',
          //     desc: `With one click, guests can easily join your restaurant's waitlist system through Chowbus Waitlist App, Google Waitlist and restaurant website reservation.`,
          //   },
          //   {
          //     title: 'Reduce manual work for staff',
          //     desc: `Your staff will love how easily they can manage the waitlist in one convenient spot. Your staff see customers who are in the waiting line, sorted by joining time, different table types, estimated waiting time, specific queues can be filtered by table type.`,
          //   },
          //   {
          //     title: 'Reduce wait times, and make waiting more engaging',
          //     desc: `Once a guest joins the waitlist, they can easily update their personal profile information or view menus, updated wait times and more. Plus, customizable messaging and two-way SMS ensure your guests show up.`,
          //   },
          // ],
        },

        {
          layout: 'row',
          direction: 'normal',
          title: 'Reduce manual work for staff',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_2.png`,
          description:
            'Your staff will love how easily they can manage the waitlist in one convenient spot. Your staff see customers who are in the waiting line, sorted by joining time, different table types, estimated waiting time, specific queues can be filtered by table type.',

          // items: [
          //   {
          //     desc: 'Guests can join waitlist through Chowbus Waitlist App, Google Waitlist, and restaurant website reservation',
          //   },
          //   {
          //     desc: `After login, guests can see the latest queue information, such as current queue tables and waiting time`,
          //   },
          //   {
          //     desc: 'Guests can receive messages after they entering their name, guest number and phone number',
          //   },
          //   {
          //     desc: 'Waitlist SMS auto sending queue number, how many tables ahead and estimated waiting time',
          //   },
          // ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: 'Reduce wait times, and make waiting more engaging',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3.png`,
          description:
            'Once a guest joins the waitlist, they can easily update their personal profile information or view menus, updated wait times and more. Plus, customizable messaging and two-way SMS ensure your guests show up.',
          // items: [
          //   {
          //     desc: 'See customers who are in the queue, sorted by join time, party size, and estimated wait time.',
          //   },
          //   {
          //     desc: `Customers who are removed from the waitlist, such as “no-shows” or “cancels” can be restored manually, and will be at the end of the queue after restoration.`,
          //   },
          //   {
          //     desc: '“Waitlist, seated, history” can be switched to find the user',
          //   },
          //   {
          //     desc: 'Easily search customer by phone number',
          //   },
          // ],
        },
      ],
    },
    zh: {
      title: '最简单、最有效地管理餐厅等位问题',
      items: [
        {
          layout: 'row',
          direction: 'reverse',
          title: '随时随地一键加入等位系统',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_1.png`,
          description:
            '无论是在餐厅线下等位机，还是在线上等位App、餐厅网站、谷歌排队，顾客仅需一键即可开始排队，获取最新的等位信息。',
        },
        {
          layout: 'row',
          direction: 'normal',
          title: '减少店员管理等位顾客的人工投入',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_2.png`,
          description:
            '店员不再需要人工登记顾客的等位信息。通过POS APP，店员可以轻松掌握当前等位情况：等位人数、加入时间、不同桌型、预计等待时间。',
          // items: [
          //   {
          //     desc: 'Guests can join waitlist through Chowbus Waitlist App, Google Waitlist, and restaurant website reservation',
          //   },
          //   {
          //     desc: `After login, guests can see the latest queue information, such as current queue tables and waiting time`,
          //   },
          //   {
          //     desc: 'Guests can receive messages after they entering their name, guest number and phone number',
          //   },
          //   {
          //     desc: 'Waitlist SMS auto sending queue number, how many tables ahead and estimated waiting time',
          //   },
          // ],
        },
        {
          layout: 'row',
          direction: 'reverse',
          title: '提供更好的用餐体验',
          cover: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3.png`,
          description:
            '顾客加入等位系统后，可以随时更新个人信息并查看电子菜单，且无需在餐厅排队等待，当用餐时间接近时，系统会通过短信通知顾客用餐。',
          // items: [
          //   {
          //     desc: 'See customers who are in the queue, sorted by join time, party size, and estimated wait time.',
          //   },
          //   {
          //     desc: `Customers who are removed from the waitlist, such as “no-shows” or “cancels” can be restored manually, and will be at the end of the queue after restoration.`,
          //   },
          //   {
          //     desc: '“Waitlist, seated, history” can be switched to find the user',
          //   },
          //   {
          //     desc: 'Easily search customer by phone number',
          //   },
          // ],
        },
      ],
    },
  },

  features2: {
    en: {
      title: `Our all-in-one Waitlist solution makes it easy to manage your waitlist, so you can focus on delighting guests and fostering loyalty`,
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: 'How customers join Waitlist ',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_1.png`,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/product_waitlist_feature_2_0.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/product_waitlist_feature_2_1.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: `Guests can join waitlist through Chowbus Waitlist App, Google Waitlist, and restaurant website reservation`,
            },
            {
              desc: `After login, guests can see the latest queue information, such as current queue tables and waiting time`,
            },
            {
              desc: 'Guests can receive messages after they entering their name, guest number and phone number',
            },
            {
              desc: 'Waitlist SMS auto sending queue number, how many tables ahead and estimated waiting time',
            },
          ],
        },

        {
          layout: 'column',
          direction: 'normal',
          title: 'How the Waitlist Works for Staff ',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_2.png`,
          // coverRatio: 415 / 1280,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3_1_1.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3_2.png`,
              ratio: 415 / 613,
            },
          ],

          items: [
            {
              title: 'Staff can see: ',
              desc: '',
              items: [
                {
                  desc: 'See customers who are in the queue, sorted by join time, party size, and estimated wait time.',
                },
                {
                  desc: 'Users who are eating from waitlist',
                },
                {
                  desc: 'Real time table information and waiting time',
                },
                {
                  desc: 'Customers who are deleted from waitlist, such as noshow, or call in to cancel can be restored manually, and will be at the end of the queue after restoration',
                },
              ],
            },
            {
              title: 'Staff can search customers:',
              desc: '',
              items: [
                {
                  desc: 'Staff can search customer by Phone number',
                },
                {
                  desc: `“Waitlist, seated, history” can be switched to find the user`,
                },
              ],
            },
          ],
        },
      ],
    },
    zh: {
      title: '简单易用的等位系统',
      items: [
        {
          layout: 'column',
          direction: 'normal',
          title: '顾客如何使用等位系统',
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/product_waitlist_feature_2_0.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/product_waitlist_feature_2_1.png`,
              ratio: 415 / 613,
            },
          ],
          items: [
            {
              desc: `可以通过餐厅线下等位机、线上等位App、餐厅网站、谷歌排队等方式取号、排队`,
            },
            {
              desc: `在排队信息页查看当前餐厅的排队信息：桌型、排队桌数、预计等待时间`,
            },
            { desc: '输入姓名、用餐人数、手机号开始排队' },
            { desc: '获取等位号，并通过短信查看最新的等位进程' },
          ],
        },
        {
          layout: 'column',
          direction: 'normal',
          title: '店员如何操作等位系统',
          // cover: `${process.env.ASSETS_PREFIX}/products/products_pos_loyalty_advance_2_2.png`,
          covers: [
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3_1_1.png`,
              ratio: 415 / 613,
            },
            {
              src: `${process.env.ASSETS_PREFIX}/products/products_pos_waitlist_advance_3_2.png`,
              ratio: 415 / 613,
            },
          ],

          items: [
            // '服务员可以通过POS的ipad端，实时查看',
            {
              // group: '服务员可以通过POS的ipad端，实时查看',
              desc: '查看正在排队中的桌数及预计等待时间，筛选查看某一桌型的等位名单',
            },
            { desc: '查看实时桌位信息和用餐时间' },
            { desc: '通过用餐状态，如等位中、已入座、用餐结束筛选查找顾客' },
            { desc: '通过手机号快速查找顾客' },
            { desc: '可以将等位状态失效（如过号、取消等）的顾客快速添加到等位列表中' },
          ],
        },
      ],
    },
  },

  customerVoiceInfos: [
    {
      img: `${process.env.ASSETS_PREFIX}/home/customervoice/customer-voice-machimachi.jpeg`,
      productLine: 'Loyalty',
      desc: {
        zh: `“自从我们在纽约中城开了第一家店之后，就一直使用Chowbus POS和他们的智能⾃助点餐机。之后我们还加入了餐厅专属会员系统。客人在智能⾃助点餐机上点完餐后，系统就会自动弹出弹窗，引导客人注册成餐厅会员。这个系统在智能⾃助点餐机的基础上，自动地将新顾客转化成忠实的回头客。用了一段时间后，我们的客单价提高了18%，餐厅利润提高了，用户关系也变得更加牢固了。我们对这个效果非常满意！”`,
        en: `“We’ve started using Chowbus POS Kiosk since we opened our first location in Midtown, New York. Later, we decided to add the Loyalty Program addition to the Kiosk. When new customers come to the store, they can directly order from the Kiosk, and the system will encourage them to sign up for the restaurant loyalty program. By leveraging the Kiosk and Loyalty Program together, the average order size increased 18%. Our customer relationships became even stronger and more profitable.”`,
      },
      restaurantName: { zh: 'Machi Machi', en: 'Machi Machi' },
      location: { zh: '纽约', en: 'New York, NY' },
      link: '/business-types/boba-tea-dessert/machi-machi',
    },
  ],
};

export default SectionContent;
